// 引入组件
import CompleteDialog from './Complete'
CompleteDialog.install = Vue => Vue.component(CompleteDialog.name, CompleteDialog);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(CompleteDialog);
}

export default CompleteDialog


// WEBPACK FOOTER //
// ./src/packages/dialogs/Complete_index.js